import { Link } from "react-router-dom";
import { Instagram, Facebook, Linkedin, Mail, Phone, MessageCircle } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="mt-24 bg-faytex-ink text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <img
            src="/faytex-logo.webp"
            alt="Faytex"
            className="h-10 w-auto mb-4 brightness-110"
            draggable="false"
          />
          <p className="text-sm text-white/70 leading-relaxed">
            The Pride of Ghana. Manufactured in Kpone. Loved across West Africa.
          </p>
        </div>

        <div>
          <h4 className="text-sm font-semibold uppercase tracking-widest mb-4 text-faytex-pink">Shop</h4>
          <ul className="space-y-2 text-sm text-white/80">
            <li><Link to="/shop">Regular Pads</Link></li>
            <li><Link to="/shop">Maternity Pads</Link></li>
            <li><Link to="/shop">Classic Pads</Link></li>
            <li><Link to="/shop">Active</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold uppercase tracking-widest mb-4 text-faytex-pink">Brand</h4>
          <ul className="space-y-2 text-sm text-white/80">
            <li><Link to="/legacy">The Faytex Legacy</Link></li>
            <li><Link to="/reimagined">Legacy Reimagined</Link></li>
            <li><Link to="/market-queens">Our Market Queens</Link></li>
            <li><Link to="/fact-or-faytex">Fact or Faytex?</Link></li>
            <li><Link to="/b2b">Contract Manufacturing</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold uppercase tracking-widest mb-4 text-faytex-pink">Get In Touch</h4>
          <ul className="space-y-3 text-sm text-white/80">
            <li className="flex items-center gap-2">
              <Mail className="w-4 h-4 flex-shrink-0" />
              <a href="mailto:hello@fayInternationalltd.com" className="hover:text-faytex-pink transition-colors break-all">hello@fayInternationalltd.com</a>
            </li>
            <li className="flex items-center gap-2">
              <Phone className="w-4 h-4 flex-shrink-0" />
              <a href="tel:+233243247352" className="hover:text-faytex-pink transition-colors">+233 0243 247 352</a>
            </li>
            <li className="flex items-center gap-2">
              <MessageCircle className="w-4 h-4 flex-shrink-0" />
              <a href="https://wa.me/233243247352" target="_blank" rel="noopener noreferrer" className="hover:text-faytex-pink transition-colors">WhatsApp: +233 0243 247 352</a>
            </li>
            <li className="pt-2 flex gap-3">
              <a
                href="https://www.instagram.com/ghanafaytex"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                data-testid="footer-instagram"
                className="hover:text-faytex-pink"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a href="https://www.facebook.com/share/1E7hvkABco/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" aria-label="Facebook"  data-testid="footer-facebook"  className="hover:text-faytex-pink"><Facebook className="w-5 h-5" /></a>
              <a
                href="https://www.linkedin.com/company/fay-international-limited/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                data-testid="footer-linkedin"
                className="hover:text-faytex-pink"
              >
                <Linkedin className="w-5 h-5" />
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/60">
          <span>© {new Date().getFullYear()} Faytex Ghana. All rights reserved.</span>
          <span>Made with care in Kpone, Ghana 🇬🇭</span>
        </div>
      </div>
    </footer>
  );
}
